module.exports = __webpack_public_path__ + "img/vje_logo.3af19808.png";